export const API_BASE_URL: string = process.env.REACT_APP_API_BASE_URL || 'https://api.lens.aivilo.ai/core/api/v1';

// AI-Operations API (GenAIOps + AgentOps)
export const AI_OPERATIONS_API_URL: string = process.env.REACT_APP_GENAIOPS_API_URL || 'https://api.lens.aivilo.ai/genaiops/api/v1';

// Static demo mode - when true, the app needs zero backend (everything mocked)
export const IS_STATIC_DEMO: boolean = process.env.REACT_APP_DEMO_MODE === 'true';
